export default "__VITE_ASSET__BRwY4MEL__"